import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Paper,
  Modal,
  Box,
  Pagination,
  CircularProgress,
  InputAdornment, // Added for clear icon
  IconButton,
  TextField, // Added for the search bar
} from "@mui/material";
import React, { useEffect, useState } from "react";
import FormMessageCategories from "./FormMessageCategories"; // Import the popup form
import HttpClient from "../../../utils/HttpClient";
import ClearIcon from "@mui/icons-material/Clear";

const MessageCategories = () => {
  const [selectedName, setSelectedName] = useState("");
  const [open, setOpen] = useState(false);
  const [categories, setCategoriesData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [usersId, setUsersId] = useState([]);
  const [loginProfile, setLoginProfile] = useState();
  const [searchTerm, setSearchTerm] = useState(""); // Combined search state
  const [filteredCategorie, setFilteredCategorie] = useState([]);
  const cardsPerPage = 5;

  const handleCardClick = async (name, _id) => {
    const res = await HttpClient.requestData(
      `service-wise-member/${_id}`,
      "GET",
      {}
    );
    if (res && res?.status) {
      for (let item of res?.data) {
        setUsersId((prev) => [...prev, item._id]);
      }
      setSelectedName(name);
      setOpen(true);
    } else {
      console.log("Error while fetching the data : ", res);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setUsersId([]);
  };

  useEffect(() => {
    const fetchCategories = async () => {
      setIsLoading(true);
      const res = await HttpClient.requestData("view-companyType", "GET", {});
      if (res && res?.status) {
        setCategoriesData(res?.data);
        setFilteredCategorie(res?.data); // Set initial filtered data
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    const fetchLoginProfile = async () => {
      const res = await HttpClient.requestData("view-profile", "GET", {});
      if (res && res?.status) {
        setLoginProfile(res?.data);
      } else {
        console.log(res?.message);
      }
    };
    fetchLoginProfile();
  }, []);

  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;

  const currentCards = filteredCategorie.slice(
    indexOfFirstCard,
    indexOfLastCard
  );
  const totalPages = Math.ceil(filteredCategorie.length / cardsPerPage);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleClearSearch = () => {
    setSearchTerm(""); // Clear the search input
    setFilteredCategorie(categories); // Reset to full data
  };

  useEffect(() => {
    if (!searchTerm) {
      setFilteredCategorie(categories);
    }
  }, [searchTerm, categories]);

  const handleSearch = () => {
    const filtered = categories.filter((item) =>
      item.type.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredCategorie(filtered);
    setCurrentPage(1); // Reset to the first page after search
  };

  return (
    <div>
      {/* Search Bar Section */}
      <div className="d-flex justify-content-end ml-4 mr-2">
        <div className="form-header">
          <Box sx={{ display: "flex", gap: 2, marginBottom: 2 }}>
            <TextField
              label="Search by Name or Company Type"
              variant="outlined"
              fullWidth
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {searchTerm && (
                      <IconButton onClick={handleClearSearch}>
                        <ClearIcon />
                      </IconButton>
                    )}
                  </InputAdornment>
                ),
              }}
            />
            <Button variant="contained" color="primary" onClick={handleSearch}>
              Search
            </Button>
          </Box>
          {isLoading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <>
              {/* Table Structure */}
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ textAlign: "left" }}>
                        Serial No
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        Company Type
                      </TableCell>
                      <TableCell style={{ textAlign: "right" }}>
                        Select
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {currentCards.map((item, index) => {
                      const { type, _id } = item;
                      const serialNumber = indexOfFirstCard + index + 1;

                      return (
                        <TableRow key={_id || index}>
                          <TableCell style={{ textAlign: "left" }}>
                            {serialNumber}
                          </TableCell>
                          <TableCell style={{ textAlign: "center" }}>
                            {type}
                          </TableCell>
                          <TableCell style={{ textAlign: "right" }}>
                            <Button
                              variant="contained"
                              onClick={() => handleCardClick(type, _id)}
                            >
                              Select
                            </Button>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>

              {/* Pagination Component */}
              <Box
                sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}
              >
                <Pagination
                  count={totalPages}
                  page={currentPage}
                  onChange={handlePageChange}
                  color="primary"
                />
              </Box>
            </>
          )}
        </div>
      </div>

      {/* Modal for the Popup */}
      <Modal
        open={open}
        onClose={handleClose}
        sx={{ display: "flex", justifyContent: "center" }}
      >
        <Box
          sx={{
            width: "100%",
            maxHeight: "100%",
            overflowX: "auto",
          }}
        >
          <FormMessageCategories
            selectedCategories={usersId}
            setUsersId={setUsersId}
            selectedName={selectedName}
            handleClose={handleClose}
            loginProfile={loginProfile}
          />
        </Box>
      </Modal>
    </div>
  );
};

export default MessageCategories;
